import React from "react";
import { ArrowRight, Building2, Handshake, Globe, Cpu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "National University of Civil Engineering",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_nuce.png",
  description: "Our primary academic partner providing research expertise. We collaborate on advanced structural engineering technologies."
}, {
  name: "Ministry of Construction",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_ministry_construction.png",
  description: "Strategic guidance on national construction standards. Ensuring compliance with the latest regulatory frameworks."
}, {
  name: "Coteccons Group",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_coteccons.png",
  description: "Implementing smart construction management systems. Jointly developing large-scale urban infrastructure projects."
}, {
  name: "Autodesk Solutions",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_autodesk.png",
  description: "Digital transformation partner for BIM integration. Enhancing design precision through software innovation."
}, {
  name: "VinConnect",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_vinconnect.png",
  description: "Pioneering smart city IoT solutions together. Integrating data-driven technologies into modern housing."
}, {
  name: "Delta Civil Engineering",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_delta.png",
  description: "Collaborating on sustainable material research. Focusing on eco-friendly high-rise construction methods."
}, {
  name: "Siemens Infrastructure",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_siemens.png",
  description: "Automating building energy management systems. Delivering efficiency through intelligent grid connections."
}, {
  name: "Hoa Binh Corporation",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/logo_hoabinh.png",
  description: "Applying robotics in construction workflows. enhancing safety and speed in complex project execution."
}];
export default function StrategicPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="đối-tác-chiến-lược" className="relative w-full py-24 bg-background overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-50" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-50" />
      
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`flex flex-col items-center text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="inline-flex items-center justify-center p-2 mb-4 rounded-full bg-secondary/10 text-secondary">
            <Handshake className="w-5 h-5 mr-2" />
            <span className="text-sm font-medium tracking-wide uppercase">Trusted Network</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6 tracking-tight">
            Strategic Partners
          </h2>
          <p className="max-w-2xl text-muted-foreground text-lg">
            Collaborating with industry leaders and academic pioneers to drive innovation in civil engineering technology.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {partners.map((partner, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
              <Card className="h-full bg-card border border-border/50 rounded-none transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_20px_40px_-15px_var(--shadow-color)] hover:border-t-4 hover:border-t-[var(--ring)] group">
                <CardContent className="p-8 flex flex-col h-full">
                  <div className="h-16 mb-8 flex items-center justify-start">
                    {}
                    <div className="relative h-full w-auto max-w-[160px] flex items-center">
                       <img src={partner.logo} alt={`${partner.name} logo`} className="h-10 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300 opacity-80 group-hover:opacity-100" />
                    </div>
                  </div>
                  
                  <div className="mt-auto">
                    <h3 className="text-lg font-semibold text-primary mb-3 group-hover:text-[var(--ring)] transition-colors">
                      {partner.name}
                    </h3>
                    <p className="text-sm text-muted-foreground font-mono leading-relaxed border-l-2 border-border pl-3 group-hover:border-[var(--ring)] transition-colors">
                      {partner.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-none bg-primary hover:bg-primary/90 text-white px-8">
            <Link to="/ContactPage">
              Become a Partner <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}